<template>
  <div class="header-wrap">
    <div class="inner_center">
      <div class="bar-left">
        <a
          href="/"
          target="_blank">
          <i class="iconfont icon-logo"/>
        </a>
        <i class="dot"/>
        <span> 支付中心</span>
      </div>

      <!-- 头像下拉 -->
      <div class="bar-right">
        <a class="bar-item" href="/introduce/company" target="_blank">全站通VIP授权介绍</a>
        <a class="bar-item" href="/introduce/company-plus" target="_blank">企业PLUS授权</a>
        <no-ssr>
          <HeaderLogin />
        </no-ssr>
      </div>

    </div>
  </div>

</template>

<script>
import HeaderLogin from '@/components/common/header/header-login';

export default {
  name: "HeaderBar",
  components: {
    HeaderLogin
  },
  data(){
    return {
      interceptMouse: true
    }
  },
}
</script>

<style lang="scss" scoped>

/* 头像下拉样式重写 */
.AvatarCombobox{
  /deep/>.avatar-box{
    width: 36px !important;
    height: 36px !important;
  }
  /deep/.text-login{
    color: #001013 !important;
  }
}


.header-wrap {
  width: 100%;
  height: 76px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0 2px 20px -1px rgba(0, 17, 144, 0.05);
  //backdrop-filter: blur(10px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 88;

  .inner_center {
    width: 1200px !important;
    padding: 0 !important;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .bar-left {
      display: flex;
      align-items: center;

      .icon-logo {
        font-size: 24px;
        color: $color-primary;
        margin-right: 10px;
      }

      .dot {
        display: inline-block;
        width: 4px;
        height: 4px;
        color: #001013;
        border-radius: 50%;
        margin: 0 10px;
        background-color: #001013;
      }

      span {
        font-size: 16px;
        color: #001013;
        line-height: 22px;
        letter-spacing: 1px;
      }
    }

    .bar-right{
      display: flex;
      align-items: center;
      .bar-item{
        font-size: 16px;
        color: #001013;
        line-height: 22px;
        letter-spacing: 1px;
        text-shadow: 0px 4px 12px rgba(0,0,0,0.05);
        margin-right: 24px;
        cursor: pointer;
        &:hover{
          color: $color-primary;
        }
      }
    }
  }

}




.avatar-box {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.6);
  margin-right: 23px;
  position: relative;
  cursor: pointer;

  .UserCombobox {
    @include Position(1, 2, 0, 55px);
    z-index: 5;
  }

  .avatar {
    display: inline-block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }

  .icon_device {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-size: 16px;
    @include LayoutFlex(1);
    @include Position(1, 3, 0, 0);
    color: #fff;

  }

  .icon-mobile {
    background: #6969FF;
  }

  .icon-wechat2 {
    background: #51CF50;
  }

  .icon-QQ2 {
    background: #06B4FD;
  }

}

.text-login {
  font-size: 16px;
  color: #001013;
  line-height: 52px;
  letter-spacing: 1px;

}

@include Screen(3) {
  .inner_center{
    width: 1920px;
    padding: 0 64px;
    box-sizing: border-box;
  }
}
</style>
